/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize EducationalMaterial Elements View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './educationalMaterialElementsView';

export const mapStateToPropsEducationalMaterialElements = mapStateToProps;
export const mapDispatchToPropsEducationalMaterialElements = mapDispatchToProps;

export default connect(
  mapStateToPropsEducationalMaterialElements,
  mapDispatchToPropsEducationalMaterialElements
)(View);
